import { useEffect, useState } from 'react';
import { TokenResponse, UseTokensParams } from '../constants/types';
import { fetchTokens } from '../services/fetchTokens';

export const useTokens = ({ clientId, redirectUri, domain }: UseTokensParams) => {
    const [tokens, setTokens] = useState<TokenResponse | null>(null);
    const [authCode, setAuthCode] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);
    
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get("code");

        if (code) 
        {
            setAuthCode(code);
            console.log("Authorization Code:", code);
            const getTokens = async () => 
            {
                try 
                {
                    const tokenResponse = await fetchTokens(domain, clientId, redirectUri, code);
                    console.log('Tokens:', tokenResponse);
                    setTokens(tokenResponse);
                    window.history.replaceState({}, document.title, window.location.pathname);
                } 
                catch (err: any) 
                {
                    setError(err.message || 'Error fetching tokens');
                    console.error('Error fetching tokens:', error);
                }
        };

        getTokens();
        }
    }, [clientId, redirectUri, domain, error]);

    const clearTokens = () => {
    setTokens(null);
    setAuthCode(null);
  };

  return { tokens, authCode, error, clearTokens };
};